module.exports = __webpack_public_path__ + "static/media/close-bold.f46298a4.svg";